import  request from '@/utils/request'

// export const getGeoData = (name)=>{
//   return request.get(`/js/geo/${name}.json`)
// }

export const getPublishList = ()=>{
  return request.post(`/weixin/getPublishList`)
}
